import React from 'react';
import { Check, Users } from "lucide-react";




const Header = () => {
  window.addEventListener("scroll", function () {
    var stickyElement = document.querySelector(".sticky-element");
    var scrollTrigger = 100; // Adjust to the distance in pixels you want

    if (window.scrollY > scrollTrigger) {
      stickyElement.classList.add("show");
    } else {
      stickyElement.classList.remove("show");
    }
  });

  return (
    <>
      <section id="sticky-element" class="sticky-element">
        <div class="banner-container">
          <div class="text-white">
            👋 We'd love to show you around!{" "}
            <a href="https://www.betterteem.com/book-a-demo" class=" underline">
              Book a demo here.
            </a>
          </div>
          <div
            id="close-sticky-btn"
            data-w-id="75255442-dc3a-85f8-8b44-b7d0bb5b1807"
            class="banner-close-btn"
          >
            <img
              src="https://cdn.prod.website-files.com/64b8df7c806237ea744702e5/64db208da72589d10ef7887c_Close.svg"
              loading="lazy"
              width="18"
              height="18"
              alt=""
            />
          </div>
        </div>
      </section>
      <header className="bg-primary-500 text-white py-12">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <div className="flex justify-center mb-10">
            <img
              src="https://customer-assets.emergentagent.com/job_turnover-expense/artifacts/grzqcm7e_BT_dark_bk.png"
              alt="Betterteem Logo"
              className="h-10 w-auto"
            />
          </div>

          <h1 className="text-4xl font-semibold mb-4">
            Employee Attrition Cost Calculator
          </h1>

          <p className="text-lg text-slate-200 max-w-3xl mx-auto leading-relaxed">
            Understand the true financial impact of employee turnover and make
            informed decisions about retention strategies with our
            industry-standard calculator.
          </p>

          <div className="flex justify-center items-center space-x-8 mt-8 text-xs">
            <div className="flex items-center space-x-2">
              {/* <Users className="h-4 w-4 text-slate-300" /> */}
              <Check />
              <span className="text-slate-300">Industry Standard</span>
            </div>
            <div className="flex items-center space-x-2">
              {/* <div className="w-2 h-2 bg-green-400 rounded-full"></div> */}
              <Check />
              <span className="text-slate-300">Instant Results</span>
            </div>
            <div className="flex items-center space-x-2">
              {/* <div className="w-2 h-2 bg-blue-400 rounded-full"></div> */}
              <Check />
              <span className="text-slate-300">Comprehensive Analysis</span>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;